import React, { Suspense, useEffect, useState } from 'react'
import classes from "./VirtualSources.module.css";
import { checkSiteConfig, clearDeviceLogs, getCamectsAPI, getDavantisesAPI, getIntegrations, getLiveViewCameras, getSchedules, getSigFoxSensorsAPI, getVirtualRelationshipsAPI } from '../../../../../Api Methods/Api';
import { useDispatch, useSelector } from 'react-redux';
import VirtualSourcesGrid from '../../../../GridList/VirtualSourcesGrid';
import CamectModalForm from './Camect/CamectModalForm';
import SigfoxModalForm from './Sigfox/SigfoxModalForm';
import { Await } from 'react-router-dom';
import Oval from 'react-loading-icons/dist/esm/components/oval';
import GatewayModalForm from './Gateway/GatewayModalForm';
import LockModalForm from './SmartLocks/LockModalForm';
import SelectCCTVIntegration from './SelectCCTVIntegration';
import AiboxForm from './Aibox/AiboxForm'
import HikvisionForm from './Hikvision/hikvisionForm';
import LiveViewCameraForm from './LiveView/LiveViewCameraForm';
import { Dialog } from 'primereact/dialog';
import Lottie from 'lottie-react';

import successAnim from '../../../../../assets/animations/success.json'
import failAnim from '../../../../../assets/animations/fail.json'
import areYouSure from '../../../../../assets/animations/areYouSure.json'
import { Button } from 'primereact/button';


const VirtualSources = ({ iglooLocks, OutPutsPinNames, InputsPinNames, deviceData, setHasDeviceChanged, DeviceDetails, apiData, device }) => {

    console.log(InputsPinNames)
    console.log(OutPutsPinNames)
    console.log(device[1])
    console.log(device[1].firmware)
    const firmware = device[1].firmware.split('.')
    const firmwareMajor = firmware[0]
    const firmwareMinor = firmware[1]
    const firmwareRevision = firmware[2]
    const siteType = device[1].type
    console.log(firmwareMajor)
    let DeviceUUID = useSelector(state => state.auth.DeviceUUID);
    const dispatch = useDispatch();
    let fetch = true
    const [_supportsCamect, _setSupportsCamect] = useState(0)
    const [sigfoxSensors, setSigfoxSensors] = useState(null);
    const [efentoSensors, setEfentoSensors] = useState(null);
    const [integrations, setIntegrations] = useState(null);
    const [gateways, setGateways] = useState(null);
    const [camects, setCamects] = useState(null);
    const [davantis, setDavantis] = useState(null);
    const [liveViewCameras, setLiveViewCameras] = useState(null);

    const [showSuccess, setShowSuccess] = useState(false)
    const [showFail, setShowFail] = useState(false)
    const [failMessage, setFailMessage] = useState("")


    const fetchVirtualSources = () => {

        const getSensors = async () => {
            const response = await getVirtualRelationshipsAPI(apiData, DeviceUUID)
            setSigfoxSensors(response[0]["sigfox"])
            setEfentoSensors(response[0]["efento"])
            setGateways(response[0]["gateways"])
            console.log(response)
        }

        const getCamects = async () => {
            return await getCamectsAPI(apiData, DeviceUUID)
        }

        const getDavantis = async () => {
            return await getDavantisesAPI(apiData, DeviceUUID)
        }

        const GetIntegrations = async () => {
            const integrations = await getIntegrations(apiData, DeviceUUID, dispatch)
            setIntegrations(integrations)
        }

        const listLiveViewCameras = async () => {
            const response = await getLiveViewCameras(apiData, DeviceUUID)
            console.log(response.data)
            if (response.success){
                setLiveViewCameras(response.data)
            }
                  
        }

        getSensors();
        setCamects(getCamects());
        GetIntegrations();
        if (device[1].liveViewEnabled == 1){
            listLiveViewCameras();
        } else {
            setLiveViewCameras([])
        }
        
        if (firmwareMajor >= 3) {
            setDavantis(getDavantis());
        }
    }

    // Fetch data on mount 
    useEffect(() => {

        const checkCamectSupport = async () => {
            const supportsCamect = await checkSiteConfig(apiData, device[1].id, dispatch)
            _setSupportsCamect(supportsCamect[0].supportsCamect)
        }

        checkCamectSupport();

        if (fetch) {
            fetchVirtualSources();
            fetch = false;

        }

    }, []);

    useEffect(() => {
        console.log(sigfoxSensors)
        console.log(efentoSensors)
        console.log(gateways)
        console.log(davantis)
        console.log(integrations)
        console.log(liveViewCameras)
    }, [sigfoxSensors, efentoSensors, gateways, davantis, integrations, liveViewCameras])

    const virtualInputsArray = [1, 2, 3, 4];
    const virtualInputs = InputsPinNames.filter((input, index) => input.pin == virtualInputsArray[index]);
    const lockPins = iglooLocks.map((lockOutputPin) => lockOutputPin.outputPin)
    const pinsAvailableToLink = OutPutsPinNames.filter(item => !lockPins.includes(item.Pin.toString()));
    console.log(OutPutsPinNames)
    const [showVirtualSource, setShowVirtualSource] = useState(null);
    const [camectDetails, setcamectDetails] = useState(null);

    //handle which camect form to show 
    const HandleSelectCamectModalForm = (AutomationID, camectDetails) => {
        console.log(AutomationID)
        console.log(camectDetails)
        if (camectDetails != null && camectDetails != undefined) {
            setShowVirtualSource(AutomationID);
            setcamectDetails(camectDetails)
        } else {
            setShowVirtualSource(AutomationID);
        }
    }

    const checkAvailableIntegrationPins = () => {
        const linkedIntegrationPinNumbers = integrations?.map(integration => integration.pin);
        const availablePins = OutPutsPinNames?.filter(output =>
            !linkedIntegrationPinNumbers?.includes(String(output.Pin))
        );

        return availablePins;
    };

    return (
        <>

         <Dialog
            header="Success"
            visible={showSuccess}
            style={{ width: "40vw" }}
            onHide={() => setShowSuccess(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <h3 style={{ color: "#6e6e6eff" }}>Action completed successfully</h3>
            <Lottie
                animationData={successAnim}
                loop={false}
                style={{ width: 250, height: 250, margin: "0px" }}
            />
            <br/>
            <Button label="Close" icon="pi pi-times" rounded severity="primary" onClick={() => setShowSuccess(false)} />
            </div>
        </Dialog>

        <Dialog
            header="Error"
            visible={showFail}
            style={{ width: "40vw" }}
            onHide={() => setShowFail(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <Lottie
                animationData={failAnim}
                loop={false}
                style={{ width: 150, height: 150, margin: "0px" }}
            />
            <h3 style={{ color: "#6e6e6eff" }}>{failMessage}</h3>
            
            <br/>
            <Button label="Close" icon="pi pi-times" rounded severity="primary" onClick={() => setShowFail(false)} />
            </div>
        </Dialog>

        <div>
            <Suspense fallback={
                <div className={classes["loadingSpinner-container"]}>
                    <Oval stroke="var(--Primary-Color)" height={200} width={100} speed={1.5} />
                </div>}>
                {console.log("Parent Render")}
                <Await resolve={Promise.all([camects, sigfoxSensors, efentoSensors, gateways, davantis, integrations, liveViewCameras])}>
                    {([loadedCamects, loadedSigFoxSensors, loadedEfentoSensors, loadedGateways, loadedDavantis, loadedIntegrations, loadedLiveViewCameras]) => (
                        <VirtualSourcesGrid
                            Camects={[loadedCamects]}
                            davantis={[loadedDavantis]}
                            sigfoxSensors={loadedSigFoxSensors}
                            efentoSensors={loadedEfentoSensors}
                            gateways={loadedGateways}
                            iglooLocks={iglooLocks}
                            integrations={loadedIntegrations}
                            liveViewCameras={loadedLiveViewCameras}
                            OutPutsPinNames={OutPutsPinNames}
                            InputsPinNames={InputsPinNames}
                            fetchVirtualSources={fetchVirtualSources}
                            HandleSelectCamectModalForm={HandleSelectCamectModalForm}
                            setShowVirtualSource={setShowVirtualSource}
                            firmware={DeviceDetails.firmware}
                            camectIntegrationType={DeviceDetails.camectIntegrationType}
                            setHasDeviceChanged={setHasDeviceChanged}
                            supportsCamect={_supportsCamect}
                            siteType={device[1].type}
                            supportsLiveView={device[1].liveViewEnabled == 1}
                        />
                    )}
                </Await>
            </Suspense>
            {showVirtualSource == 7 && <SelectCCTVIntegration HandleSelectCamectModalForm={HandleSelectCamectModalForm} firmwareMajor={firmwareMajor} firmwareMinor={firmwareMinor} supportsCamect={_supportsCamect} siteType={siteType} />}

            {/* {showVirtualSource == 12 && <AiboxModalForm setShowVirtualSource={setShowVirtualSource} outputs={OutPutsPinNames} fetchVirtualSources={fetchVirtualSources}/>} */}
            {showVirtualSource == 12 && <AiboxForm setShowVirtualSource={setShowVirtualSource} outputs={checkAvailableIntegrationPins()} fetchVirtualSources={fetchVirtualSources} />}

            {showVirtualSource == 1 && <SigfoxModalForm setShowVirtualSource={setShowVirtualSource} inputs={virtualInputs} virtualType={"SIGFOX RE:SURE"} fetchVirtualSources={fetchVirtualSources} />}
            {showVirtualSource == 4 && <SigfoxModalForm setShowVirtualSource={setShowVirtualSource} inputs={virtualInputs} virtualType={"IOTA"} fetchVirtualSources={fetchVirtualSources} />}

            {showVirtualSource == 5 && <GatewayModalForm setShowVirtualSource={setShowVirtualSource} inputs={virtualInputs} virtualType={"Gateway"} fetchVirtualSources={fetchVirtualSources} />}

            {showVirtualSource == 6 && <LockModalForm setShowVirtualSource={setShowVirtualSource} outputs={pinsAvailableToLink} virtualType={"Padlock"} fetchVirtualSources={fetchVirtualSources} setHasDeviceChanged={setHasDeviceChanged} />}

            {showVirtualSource == 0 && <CamectModalForm setShowVirtualSource={setShowVirtualSource} title={"Add camect"} subTitle={"What are the camect details?"} placeholders={{ placeholder1: "IP/Domain Name...", placeholder2: "Enter Password" }} fetchVirtualSources={fetchVirtualSources} />}
            {showVirtualSource == 3 && <CamectModalForm setShowVirtualSource={setShowVirtualSource} title={"Edit camect"} subTitle={"What are the new details?"} placeholders={{ placeholder1: "IP/Domain Name...", placeholder2: "Enter Password" }} camect={camectDetails} fetchVirtualSources={fetchVirtualSources} />}
            {showVirtualSource == 8 && <CamectModalForm setShowVirtualSource={setShowVirtualSource} title={"Add Davantis"} subTitle={"What are the Davantis details?"} placeholders={{ placeholder1: "IP/Domain Name...", placeholder2: "Enter Password" }} fetchVirtualSources={fetchVirtualSources} />}
            {showVirtualSource == 9 && <HikvisionForm setShowVirtualSource={setShowVirtualSource} outputs={checkAvailableIntegrationPins()} fetchVirtualSources={fetchVirtualSources} />}
            {showVirtualSource == 10 && <CamectModalForm setShowVirtualSource={setShowVirtualSource} title={"Add Ajax"} subTitle={"What are the Ajax details?"} placeholders={{ placeholder1: "IP/Domain Name...", placeholder2: "Enter Password" }} fetchVirtualSources={fetchVirtualSources} />}
            {showVirtualSource == 11 && <CamectModalForm setShowVirtualSource={setShowVirtualSource} title={"Add Dahua"} subTitle={"What are the Dahua details?"} placeholders={{ placeholder1: "IP/Domain Name...", placeholder2: "Enter Password" }} fetchVirtualSources={fetchVirtualSources} />}
            {showVirtualSource == 13 && <LiveViewCameraForm setShowVirtualSource={setShowVirtualSource} fetchVirtualSources={fetchVirtualSources} setShowSuccess={setShowSuccess} setShowFail={setShowFail} setFailMessage={setFailMessage} />}
        </div>

        </>
    )
}

export default VirtualSources;
